<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addController" v-if="permissionCodes.indexOf('004001001') !== -1"/>
        <button-upload
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          v-if="permissionCodes.indexOf('004001004') !== -1"
          @getpage="getPage"
          value="导入"/>
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('004001005') !== -1"
          value="导出"/>
      </div>
      <input-search placeholder="设备名称/设备编号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @deleteLine="deleteLine" @changeSelection="changeSelection" @getTemporaryQRCode="getTemporaryQRCode" @getUnlicensedQRCode="getUnlicensedQRCode" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" tableOperationWidth="500px" />

    <el-dialog
      title="标签"
      :visible.sync="tipDialogVisible"
      width="40%">
      <div style="margin: 20px 0;" ref="imageWrapper">
        <canvas class="qrcode" ref="qrCodeUrl" id="createCode"></canvas>
        <div style="width: 280px;margin: 0 auto;text-align: center;font-size: 18px;" >{{currentElectricDeviceName}}</div>
      </div>
      <el-button size="mini" plain @click="setImage">保存图片</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="tipDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import html2canvas from "html2canvas";
import QrCodeWithLogo from "qr-code-with-logo";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-device-management",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "设备管理"
        }
      ],
      addController: "parking-device-add",
      uploadUrl: "",
      exportUrl: "",
      tableHead: [
        {
          prop: "name",
          label: "设备名称"
        },
        {
          prop: "code",
          label: "设备编号"
        },
        {
          prop: "personName",
          label: "责任人姓名"
        },
        {
          prop: "passTypeText",
          label: "进出类型",
          width: "120px"
        },
        {
          prop: "deviceStatus",
          isStatus: true,
          label: "设备状态",
          width: "120px"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: ""
      },
      operationArr: [
        "current",
        "temporaryQRCode",
        "unlicensedQRCode",
        "delete"
      ],

      tipDialogVisible: false,
      tipContent: "",
      currentElectricDeviceName: ""
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importParkingDevice;
    // this.exportUrl = `${api.exportParkingDevice}?yq-app-code=${bus.global.yqCode}`
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportParkingDevice}?yq-app-code=${
        bus.global.yqCode
      }&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`;
    },
    // 获取设备
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;

      this.$axios
        .post(api.getParkingDevicePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            let responsiblePersonNameArr = [];
            if (v.parkingDeviceResponsibleList) {
              v.parkingDeviceResponsibleList.map(list => {
                responsiblePersonNameArr.push(list.name);
              });
            }
            if (v.passType === "1") {
              v.passTypeText = "进";
            } else if (v.passType === "2") {
              v.passTypeText = "出";
            } else if (v.passType === "3") {
              v.passTypeText = "进/出";
            }
            v.responsiblePersonName = responsiblePersonNameArr.join(",");
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取设备信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/park_server/parking_device_current/${code}`
      });
    },
    deleteLine(code) {
      let codes = code.join(",");
      this.$axios
        .post(api.deleteParkingDeviceByCode, { codes: codes })
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },

    // 临停收款二维码
    getTemporaryQRCode(data) {
      this.tipDialogVisible = true;
      this.tipContent = `https://yq.damaiiot.com/gyH5Index.html#/unifiedExport/${bus.global.yqCode}/${data.code}`;
      this.currentElectricDeviceName = data.deviceName;
      this.getCodes();
    },

    // 无牌车进出二维码
    getUnlicensedQRCode(data) {
      this.tipDialogVisible = true;
      this.tipContent = `https://yq.damaiiot.com/gyH5Index.html#/unifiedExport/${bus.global.yqCode}/${data.code}`;
      this.currentElectricDeviceName = data.deviceName;
      this.getCodes();
    },

    getCodes() {
      setTimeout(() => {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById("createCode"),
          content: this.tipContent,
          width: 400
        }).catch();
      }, 100);
    },

    setImage() {
      let that = this;
      html2canvas(this.$refs.imageWrapper).then(canvas => {
        let image = canvas.toDataURL("image/jpeg");
        let $a = document.createElement("a");
        $a.setAttribute("href", image);
        $a.setAttribute("download", that.currentElectricDeviceName);
        $a.click();
      });
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingDevice/ParkingDeviceManagement.vue